import React, { Component } from 'react';

import SidebarComponent from '../components/SidebarComponent';
import NavbarComponent from '../components/NavbarComponent';
import HeaderComponent from '../components/HeaderComponent';
import FormOpenTableComponent from '../components/FormOpenTableComponent';
import { getOpenTable, updateOpenTable, cancelOpenTable, OPEN_TABLE_STATUS, CHARGE_MODE_LABEL } from '../utils/openTablesApi';
import { validateSession } from '../utils/functions';
import { navigateTo } from '../utils/navigation';
import { copyLink, openTablePublicUrl } from '../utils/publicLinks';

// Editar / cancelar una mesa abierta (FR-006, FR-007, FR-012). Molde: EditEventPage,
// con el id por parámetro de ruta (/editOpenTable/:id, precedente /editEmailTemplate/:key).
class EditOpenTablePage extends Component {
    constructor() {
        super();
        this.state = { checked: false, role: 0, id: null, openTable: null, disabled: false };
    }

    async componentDidMount() {
        const role = await validateSession();
        const id = this.props.match.params.id;
        // Llega con `publicada` desde el alta: se muestra el link para compartir arriba.
        const recienPublicada = !!(this.props.location && this.props.location.state && this.props.location.state.publicada);
        this.setState({ checked: true, role, id, recienPublicada });
        this.fetchOpenTable(id);
    }

    fetchOpenTable = async (id) => {
        try {
            const data = await getOpenTable(id);
            this.setState({ openTable: (data && data.openTable) || null });
        } catch (error) {
            console.error('No se pudo cargar la mesa abierta:', error);
            alert(error.message || 'Error de conexión');
        }
    }

    handleChangeData = async (value) => {
        this.setState({ disabled: true });
        try {
            await updateOpenTable(this.state.id, value);
            navigateTo('/openTables');
        } catch (error) {
            console.error('No se pudo actualizar la mesa abierta:', error);
            alert(error.message || 'Error de conexión');
            this.setState({ disabled: false });
        }
    }

    // FR-012…FR-015, FR-061: cancelar avisa por email a los anotados; los pagos online
    // acreditados quedan "por devolver" (la devolución en MP es manual, TD-14).
    cancel = async () => {
        const aviso = '¿Cancelar esta mesa abierta?\n\n'
            + 'Se libera la mesa física, se avisa por email a los anotados y deja de ofrecerse en la web. '
            + 'Las inscripciones con pago online acreditado quedan "Por devolver" (la devolución se hace a mano en MercadoPago).';
        if (!window.confirm(aviso)) {
            return;
        }
        this.setState({ disabled: true });
        try {
            const data = await cancelOpenTable(this.state.id);
            const porDevolver = (data && data.refundPending) || 0;
            if (porDevolver > 0) {
                alert(`Mesa cancelada. Quedaron ${porDevolver} inscripción(es) por devolver: revisalas en Inscripciones.`);
            }
            this.setState({ disabled: false });
            this.fetchOpenTable(this.state.id);
        } catch (error) {
            console.error('No se pudo cancelar la mesa abierta:', error);
            alert(error.message || 'Error de conexión');
            this.setState({ disabled: false });
        }
    }

    // El link público sólo existe mientras la mesa está publicada: cancelada o realizada, la
    // tienda contesta "ya no está disponible".
    renderShareNotice = () => {
        const openTable = this.state.openTable;
        if (!this.state.recienPublicada || !openTable || openTable.status !== 'published') return null;
        const url = openTablePublicUrl(openTable.id);
        return (
            <div className="card card-small mb-4" style={{ borderLeft: '4px solid #17c671' }}>
                <div className="card-body">
                    <div className="mb-2"><b>Mesa abierta publicada.</b> Este es el link para compartir:</div>
                    <div className="input-group">
                        {/* readOnly y seleccionable: si el navegador no deja copiar, se copia a mano. */}
                        <input type="text" className="form-control" readOnly value={url} onFocus={(e) => e.target.select()} />
                        <div className="input-group-append">
                            <button type="button" className="btn btn-success" onClick={() => copyLink(url)}>
                                Copiar link
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    renderStatusActions = () => {
        const openTable = this.state.openTable;
        if (!openTable) return null;
        const status = OPEN_TABLE_STATUS[openTable.status] || { label: openTable.status };
        return (
            <div className="card card-small mb-4">
                <div className="card-body d-flex align-items-center flex-wrap">
                    <span className="mr-3"><b>Estado:</b> {status.label}</span>
                    <span className="mr-3 text-muted">
                        Anotados: {openTable.confirmed}/{openTable.cupo} · {CHARGE_MODE_LABEL[openTable.chargeMode] || openTable.chargeMode}
                    </span>
                    {openTable.status === 'published' && (
                        <button type="button" className="btn btn-sm btn-outline-danger" disabled={this.state.disabled} onClick={this.cancel}>
                            Cancelar mesa abierta
                        </button>
                    )}
                </div>
            </div>
        );
    }

    render() {
        if (!this.state.checked) {
            return (<div></div>);
        }
        const openTable = this.state.openTable;
        return (
            <div className="container-fluid">
                <div className="row">
                    <SidebarComponent itemSelected={45} role={this.state.role} />
                    <main className="main-content col-lg-10 col-md-9 col-sm-12 p-0 offset-lg-2 offset-md-3">
                        <NavbarComponent role={this.state.role} />
                        <div className="main-content-container container-fluid px-4 mb-4">
                            <div className="d-flex justify-content-between align-items-center">
                                <div style={{ flex: '1 1 auto', minWidth: 0 }}>
                                    <HeaderComponent title="Mesas abiertas" subtitle="Editar mesa abierta" />
                                </div>
                                {openTable && (
                                    <div className="text-nowrap" style={{ flex: '0 0 auto' }}>
                                        <button type="button" className="btn btn-white" onClick={() => navigateTo(`/openTableSignups/${this.state.id}`)}>
                                            Ver inscripciones
                                        </button>
                                        {openTable.status === 'published' && (
                                            <button type="button" className="btn btn-white ml-2" title={openTablePublicUrl(openTable.id)}
                                                onClick={() => copyLink(openTablePublicUrl(openTable.id))}>
                                                Copiar link
                                            </button>
                                        )}
                                    </div>
                                )}
                            </div>
                            {openTable != null ? (
                                <>
                                    {this.renderShareNotice()}
                                    {this.renderStatusActions()}
                                    {openTable.status === 'published' ? (
                                        <FormOpenTableComponent
                                            editMode
                                            initial={openTable}
                                            onChangeData={this.handleChangeData}
                                            disabled={this.state.disabled}
                                        />
                                    ) : (
                                        <div className="card card-small mb-4">
                                            <div className="card-body p-4 text-muted">
                                                Una mesa abierta {(OPEN_TABLE_STATUS[openTable.status] || { label: openTable.status }).label.toLowerCase()} no se puede editar.
                                            </div>
                                        </div>
                                    )}
                                </>
                            ) : (
                                <div className="card card-small mb-4"><div className="card-body p-4">Cargando…</div></div>
                            )}
                        </div>
                    </main>
                </div>
            </div>
        );
    }
}

export default EditOpenTablePage;
